<template>
    <div class="w-full">
        <div>
            <p class="text-left mx-8 mt-4">
                Please provide details of each undergraduate and/or postgraduate institution that you have attended and provide details about all qualifications
                attained (maximum of 5). This will ensure that the Admissions Team has all information to hand and are able to assess your application quickly.
            </p>
            <p class="text-left mx-8 mt-4">
                If this is a UK institution please select from the drop-down list, otherwise, please select ‘Other European Institution’ Or ‘Other Overseas Institution’
                and provide the name.
            </p>
        </div>
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <div class="p-4">
            <div v-for="(record, index) in education" :key="record" class="w-full">
                <div>
                    <education-details-form
                        :education-data="record"
                        :application-reference="applicationReference"
                        :item-index="index"
                        :countries-of-domicile-list="countriesOfDomicileList"
                        :institutions-list="institutionsList"
                        :ins-overseas-options="insOverseasOptions"
                        :programme-code="programmeCode"
                        @delete="removeOne"
                    />
                </div>
            </div>
        </div>

        <div v-if="educationCount < 5">
            <button class="btn-green mb-8" @click="newEducation">Add <span v-if="educationCount > 0">other</span> education record</button>
        </div>
    </div>
</template>

<script>

import EducationDetailsForm from '@/views/Application/Details/EducationDetailsForm'

export default {
    components: {
        EducationDetailsForm,
    },
    props: {
        priorEducation: Object,
        applicationReference: String,
        countriesOfDomicileList: Object,
        programmeCode: String,
        institutionsList: Array,
        insOverseasOptions: Array,
    },
    data() {
        return {
            education: Object,
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            addEducation: false,
        }
    },
    computed: {
        educationCount() {
            return this.education.length + ((this.addEducation === true)? 1: 0)
        },
    },
    mounted() {
        this.education = this.priorEducation

        if (this.education.length === 0)
        {
            this.newEducation()
        }
    },
    methods: {
        removeOne(index) {
            this.education.splice(index, 1)
        },
        newEducation() {
            this.education.push({
                reference: null,
                start_date: null,
                end_date: null,
                country_id: null,
                institution_name: null,
                overseas_institution: null,
                online_distance_learning: null,
                qualification_type: null,
                subject: null,
                final_result: null,
                tuition_language: null,
            })
        },
    },
}
</script>